import React from "react";
import { Spinner } from 'reactstrap';
import "../../scss/dashboard/enAprobacion.css";
import AprobDiv from "./AprobDiv";
import NoFoldersScreen from "./Publicadas/noFoldersScreen";
import { useRequestedTemplateList } from "../../api/hooks/templates";

function EnAprobacion() {
  const { data = {}, isLoading } = useRequestedTemplateList({
    status: 'REQUESTED|IN_REVIEW|REJECTED'
  });

  return (
    <section className="dashboardAbogados__aprobacion">
      {
        isLoading && 
        <div className="d-flex justify-content-center align-items-center mb-4">
            <Spinner />
        </div>
      }
    
      {
        !isLoading && data?.data?.map(requestedTemplate => (
          <AprobDiv {...requestedTemplate} />
        ))
      }
      {
        
        !data?.data?.length && !isLoading && <NoFoldersScreen width={"100%"} text={"Sin plantillas para mostrar"} />
      }
    </section>
  );
}

export default EnAprobacion;
